import { z } from 'zod';

export const schemaSkagFieldValidationError = z.object({
    error: z.object({
        code: z.string(),
        data: z.record(z.string(), z.array(z.string())).optional(),
        description: z.string(),
    }),
    success: z.literal(false),
});

export type SchemaSkagFieldValidationError = z.infer<typeof schemaSkagFieldValidationError>;

export const schemaSkagAuthError = z.object({
    code: z.string(),
    errors: z.union([z.string(), z.array(z.string())]),
    success: z.literal(false),
});

export type SchemaSkagAuthError = z.infer<typeof schemaSkagAuthError>;

// Doc-style error envelope. Observed only for /upload-document HTTP 404 with error_type='credit_not_found'.
// Docs claim error_type values { auth_error, data_error, data_format_error } but those have not been
// observed in the sandbox; error_type is therefore left as an open string.
export const schemaSkagDocErrorEnvelope = z.object({
    error_code: z.string(),
    error_description: z.string(),
    error_type: z.string(),
    status: z.literal('error'),
});

export type SchemaSkagDocErrorEnvelope = z.infer<typeof schemaSkagDocErrorEnvelope>;
